// extracted by mini-css-extract-plugin
export default {"wrapper":"Services_wrapper__9EQzV","title":"Services_title__TKkvv","items":"Services_items__5Bda7"};